export const blockIconsImageAudiotrack = (
	<span className='material-symbols-outlined'>audiotrack</span>
);
